import Vue from 'vue'
import { controlGoodsApplyTips, applyShoppingSms } from '~fetch/common'
import {
  selectBatchBuy
} from './../fetch/home/index.js'
import {
  loadPromotionDetail
} from './../fetch/categorylist/index.js'
import { ResultCode } from '~const/ResultCode'
import {
  Toast, Dialog
} from 'vant'
Vue.use(Toast)
  .use(Dialog)
export default {
  data () {
    return {
      // 控制购物车弹窗开关
      showcart: false,
      // 控制缺货弹窗开关
      shownogoods: false,
      // 父传给子的值,购物车缺货弹窗data
      cartItem: {},
      // 多批号的值
      product: {},
      // 多批号因区域被限制的商品标识
      region: 0,
      batchTxt: ''
    }
  },
  computed: {
    /**
     * @description 数量的加减step(step input框的初始值)
     * @author cc
     * @date 2019-11-7
     * @param {data} choose 0 不支持散装 1 支持散装 ispack==on 散装规格（成倍的加减） isRealSeparate 1 可拆销 0 不可拆销
     * @return {num:渲染input初始化数量,judgeNornSure:判断规格是否正常的最小值}
     */
    steps () {
      return function (choose, pack, isRealSeparate) {
        // num:渲染初始化数量 judgeNornSure:判断规格是否正常的最小值
        var obj = { num: null, judgeNornSure: null }
        if (choose === 0) {
          // 1.不支持散装
          // 详情页改版后这里要调整
          if (pack.length === 0) {
            // 1.2无中包装（中包装是指商品有多种包装规格）
            obj.num = 1
            obj.judgeNornSure = 1
            return obj
          } else {
            // 1.3有中包装
            if (isRealSeparate * 1 === 0) {
              // 1.31可拆销（是）
              obj.num = 1
              obj.judgeNornSure = pack[0].num * 1
              return obj
            } else if (isRealSeparate * 1 === 1) {
              // 1.32不可拆销（否），刚一定要选择一个中包装规格
              // pack数组中is_pack on 索引为1 is_pack on 为中包装规格
              pack.forEach(item => {
                if (item.is_pack === 'on') {
                  obj.num = item.num * 1
                }
              })
              obj.judgeNornSure = pack[0].num * 1
              return obj
            }
          }
        } else if (choose === 1) {
          // 2.支持散装
          if (pack.length === 0) {
            // 2.2无中包装（中包装是指商品有多种包装规格）
            obj.num = 0.001
            obj.judgeNornSure = 0.001
            return obj
          } else {
            // 2.3有中包装
            if (isRealSeparate * 1 === 0) {
              // 1.31可拆销（是）
              obj.num = 0.001
              obj.judgeNornSure = pack[0].num * 1
              return obj
            } else if (isRealSeparate * 1 === 1) {
              // 1.32不可拆销（否），刚一定要选择一个中包装规格
              // pack数组中is_pack on 索引为1 is_pack on 为中包装规格
              pack.forEach(item => {
                if (item.is_pack === 'on') {
                  obj.num = item.num * 1
                }
              })
              obj.judgeNornSure = pack[0].num * 1
              return obj
            }
          }
        }
      }
    },
    /**
     * @description step组件最大值数据处理
     * @author cc
     * @date 2019-11-16
     * @param {data} item 每一项
     * @param {data} type 1:中包装
     */
    maxHandle () {
      return function (item, type) {
        if (this.getLoadSettingStatus.data.is_empty_stock === 1) {
          // 零库存可购买(普通商品和满赠商品，type=1 4 5 可零库存购买)
          if (item.type === 8 && item.presell_stock * 1 !== 0) {
            return +item.presell_stock
          } else if (item.type === 1 || item.type === 4 || item.type === 5 || item.for_type === 4 || item.for_type === 1 || item.for_type === 5) {
            return Infinity
          } else {
            return +item.goodsstock
          }
        } else {
          // 零库存不可购买
          if (item.type === 8) {
            return item.presell_stock * 1
          } else {
            return +item.goodsstock
          }
        }
      }
    }
  },
  methods: {
    /**
     *   @description 拨打电话
     *   @param number 拨打电话号码
     */
    phone (number) {
      const link = document.createElement('a')
      var src = 'tel:' + number
      link.setAttribute('href', src)
      link.setAttribute('target', '_blank')
      const evt = document.createEvent('MouseEvents')
      evt.initMouseEvent('click', true, true)
      link.dispatchEvent(evt)
    },
    /**
     *   @description 购物车议价商品
     */
    async applyBargain (item) {
      let data = await applyShoppingSms({
        goods_id: item.id,
        distributor_member_id: item.distributor_member_id
      })
      Dialog.confirm({
        message: `尊敬的用户 ，该商品为控销商品，请联系当地服务员：${data.distributor_info.contacter}  ${data.distributor_info.mobile} `,
        confirmButtonText: '拨打电话',
        cancelButtonText: '继续浏览'
      }).then(() => {
        this.phone(data.distributor_info.mobile)
        // window.location.href = 'tel:' + data.distributor_info.mobile
        // on confirm
      }).catch(() => {
        // on cancel
      })
    },
    /**
     *   @description 购物车促销套餐详情
     */
    async goPromotion (id) {
      // 1.委托配送是否参加促销套装
      let { data, status, info } = await loadPromotionDetail({ id: id })
      if (status === ResultCode.SUCCESS) {
        this.showCartPromot = true
        this.promotCartData = {
          ...data.promotion_data,
          choose: 0,
          num: 1,
          step: 1
        }
        this.promotCartData.stock = +this.promotCartData.stock
      } else {
        // 无权购买或者套餐已下架
        Toast(info.msg)
      }
    },
    /**
     * @description 选择批号
     */
    async selectBatchBuy (item) {
      let { data } = await selectBatchBuy({
        goods_id: item.id
      })
      if (data.length) {
      //= ====== 同步中包装，并中包装中有值时,没值时显示：无======
        if (data[0].pack !== null) {
          var obj = this.steps(
            item.choose,
            data[0].pack.goods_pack,
            data[0].pack.is_big_pack
          )
          if (obj) {
            if ((item.choose === 0 && obj.judgeNornSure === 0.001) || (item.choose === 1 && obj.judgeNornSure === 1)) {
            // 当包装规格有误时，步长为0
              item.step = 0
            } else {
              item.step = obj.num
            }
            item.num = obj.num
            item.pack = data[0].pack.goods_pack
            item.judgeNornSure = obj.judgeNornSure
          }
        } else {
        // 这里看下要区分整装和散装不
          item.num = item.choose ? 0.001 : 1
          item.step = item.num
          item.pack = '无'
          item.judgeNornSure = item.num
        }
        this.product = {
          ...item,
          data: data,
          priceBatch: data[0].price,
          hidestockeBatch: data[0].hidestock,
          stockBatch: data[0].stock,
          idBatch: data[0].id,
          last_dateBatch: data[0].last_date,
          is_real_separate: data[0].pack && data[0].pack.is_big_pack === 1 ? 1 : 0
        }
      } else {
        this.region = 1
      }
    },
    /**
     * @description 包装规格有误
     * @author cc
     * @date 2019-4-10
     * @param {data} choose 0 不支持散装 1 支持散装 judgeNornSure 判断规格是否有误的值
     */
    packRrror (choose, judgeNornSure) {
      if (choose === 0 && judgeNornSure === 0.001) {
        Toast('包装规格有误，请联系客服')
        return false
      } else if (choose === 1 && judgeNornSure === 1) {
        Toast('包装规格有误，请联系客服')
        return false
      } else {
        return true
      }
    },
    /**
     * 对预售图标颜色进行数据处理（做预售专区时，将此和cartIconColor合并）
     */
    preIconColor (item) {
      if (item.is_view === 1) {
        // 区域经销
        return true
      } else if (this.getLoadSettingStatus.data.is_delivery_flag === 1) {
        return true
      } else if (item.presell_stock * 1 === 0) {
        return true
      } else {
        return false
      }
    },
    // 与零库存无关(首页特价和秒杀专用)
    cartIconColorno0 (item) {
      if (item.is_view === 1) {
        // 区域经销
        return true
      } else if (this.getLoginStatus.data.member_id * 1 !== 0 && (item.goodsstock * 1 <= 0 || item.stock * 1 === 0)) {
        return true
      } else {
        return false
      }
    },
    /**
     * 对购物车图标颜色进行数据处理
     */
    cartIconColor (item) {
      // 普通商品(包括活动商品)或者满赠商品，零库存可超买
      if (item.is_view === 1) {
        return true
      } else if (this.getLoginStatus.data.member_id * 1 !== 0 && item.goodsstock * 1 <= 0 && this.getLoadSettingStatus.data.is_empty_stock === 0) {
        return true
      } else {
        return false
      }
    },
    /**
     * @description 购物车区域经销
     *
     */
    async regionSales (item) {
      let res = await controlGoodsApplyTips({
        goods_id: item.goods_id
      })
      if (res.status === 0) {
        Dialog.confirm({
          message: res.data.tips,
          confirmButtonText: '拨打'
        }).then(() => {
          this.phone(res.data.tel)
          // window.location.href = 'tel:' + res.data.tel
        }).catch(() => {
          // on cancel
        })
      }
    },
    /**
     * @description 购物车弹窗
     * @param {data} item 商品所有数据
     * @param {data} cartColor 弹的是缺货弹窗（true） or 购物车弹窗 (false)
     * @param {data} noAlert 不需要弹缺货弹窗的标识（点击无反应）
     *
     */
    async cartBtnAlter (item, cartColor, noAlert) {
      // 父edit儿
      if (this.getLoginStatus.data.member_id === 0) {
        // 1.判断是否登录(未登录)
        location.href = '/visitor/login'
      } else {
        // 2.已登录
        // 1分销商不可购物
        if (this.getLoginStatus.data.role * 1 === 3) {
          Toast('分销商不可购物')
          return false
        }
        // 2采购商
        // 1、区域经销
        if (item.is_view === 1) {
          this.regionSales(item)
          return false
        }

        if (item.pack === '无') {
          item.pack = []
        }
        // 添加商品购买数量字段
        let obj = this.steps(item.choose, item.pack, item.is_real_separate)
        if (obj) {
          if ((item.choose === 0 && obj.judgeNornSure === 0.001) || (item.choose === 1 && obj.judgeNornSure === 1)) {
            // 当包装规格有误时，步长为0
            item.step = 0
          } else {
            item.step = obj.num
          }
          item.num = obj.num
          item.judgeNornSure = obj.judgeNornSure
        }
        // 添加商品库存最大值
        if (this.maxHandle(item)) {
          item.max = this.maxHandle(item)
        }
        // 对图片进行处理
        let showimage = Array.isArray(item.image) ? item.image[0] : item.image
        this.$set(item,'showimage',showimage)

        // 1.预售商品
        if (item.type === 8) {
          if (this.getLoadSettingStatus.data.is_delivery_flag === 1) {
            // 1.配送商品不参与预售活动
            Toast('委托配送商品不参与预售活动')
            return false
          } else if (+item.presell_stock) {
            // this.showCartOrNogoods = false
            // this.showShowCart = true
            this.showcart = true
            this.cartItem = item
          }
        } else {
          // 议价商品
          if (item.is_bargain === 1 && item.tag === 2) {
            this.applyBargain(item)
            return false
          }
          if (cartColor) {
            // 不弹缺货弹窗
            if (noAlert) {
              return false
            }
            // 1.库存小于0&&不允许0库存购买，缺货提醒弹窗
            // this.showShowCart = true
            // this.showCartOrNogoods = true
            this.shownogoods = true
            this.cartItem = item
          } else {
            // 促销套装强制购买
            if (item.is_single_promotion_goods) {
              // 促销套装弹窗
              this.goPromotion(item.for_id)
              return false
            }
            // 4.多批号商品
            if (item.is_batch_number === 1) {
              // 同步请求
              setTimeout(async () => {
                await this.selectBatchBuy(item)
                // 多批号商品被地区限制时
                if (this.region) {
                  this.cartItem = item
                  this.cartItem.region = 1
                  this.cartItem.pack = []
                  this.cartItem.num = 1
                  this.cartItem.step = 1
                  this.cartItem.hidestockeBatch = 0
                  this.cartItem.priceBatch = this.cartItem.price
                  this.cartItem.last_dateBatch = this.cartItem.last_date
                } else {
                  this.cartItem = this.product
                }
                this.batchTxt = this.cartItem.data[this.$refs.shopCart.activeBatch].batch_code
              })
            } else {
              this.cartItem = item
            }
            // 5.购物车弹（0库存可购买已判断）
            // this.showCartOrNogoods = false
            // this.showShowCart = true
            this.showcart = true
          }
        }
      }
    }
  }
}
